import * as React from 'react';

const square = require('../resources/sponsors/squarePharmaceuticals.jpg');
const incepta = require('../resources/sponsors/inceptaPharmaceuticals.jpg');
const beximco = require('../resources/sponsors/beximcoPharmaceuticals.jpg');
const mediplus = require('../resources/sponsors/mediplus.jpg');
const aci = require('../resources/sponsors/ACIPharmaceuticals.png');
const ziska = require('../resources/sponsors/ziskaPharmaceuticals.jpg');
const opsonin = require('../resources/sponsors/opsoninPharmaceuticals.png');
const renata = require('../resources/sponsors/renataPharmaceuticals.png');
const unimed = require('../resources/sponsors/unimed&Unihealth.png');
const jayson = require('../resources/sponsors/jaysonPharmaceuticals.png');
const drug = require('../resources/sponsors/drugInternational.jpg');
const alok = require('../resources/sponsors/alokPharmaceuticals.png');

export const Sponsor = () => (
  <div>
    <div className="fl w-100">
        <p className="tc pv2 fw5 f2 bg_orange white">Sponsor List</p>
      </div>
  
  <div className="center ph3-ns">
    <div className="cf ph2-ns">
      <div className="fl w-100 pa2">
        <div className="mw9 center">
          <div className="cf flex-ns items-center pv4">
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={square} alt="square" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={incepta} alt="incepta" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={beximco} alt="beximco" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={mediplus} alt="mediplus" />
            </div>
          </div>
          <div className="cf ph2-ns flex-ns items-center pv4">
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={aci} alt="aci" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={ziska} alt="ziska" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={opsonin} alt="opsonin" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={renata} alt="renata" />
            </div>
          </div>
          <div className="cf ph2-ns flex-ns items-center pv4">
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={unimed} alt="unimed" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={jayson} alt="jayson" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={drug} alt="drug" />
            </div>
            <div className="fl w-100 w-25-ns pa2 tc">
              <img src={alok} alt="alok" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
);


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/Sponsor.tsx